// Avoid conflicts with Sitefinity's built-in AMD loader
if (typeof define === 'function' && define.amd) {
    var SitefinityDefine = window.define;
    window.define = null;
}

//= include _appius.equalise.js

//= include vendor/_bootstrap.js
//= include vendor/_jquery.cookiebar.js
//= include vendor/_slick.js
//= include vendor/_cookie.js
//= include vendor/_handlebars.min-v4.0.12.js

//= include _appius.mobileNav.js
//= include _appius.backToTop.js
//= include _appius.scroller.js
//= include _appius.sfBreadcrumb.js
//= include _appius.responsiveTableHeadings.js
//= include _appius.infinity-numbers.js
//= include _appius.jumplist.js
//= include _appius.savingsCalculator.js
//= include _appius.affordabilityCalculator.js
//= include _appius.familyMortgageRepaymentCalculator.js
//= include _appius.tooltips.js
//= include _appius.comparisonTool.js

//= include _appius.search.js
//= include _appius.tableSort.js

//= include _fbs.calcs.js
//= include _fbs.maxTermCalc.js
//= include _fbs.addressLookup.js
//= include _appius.fieldToggle.js
//= include _appius.fieldValidation.js
//= include _fbs.securePaymentForm.js
//= include _mortgage-products-field.js
//= include _address-lookup-field.js

// Restore Sitefinity's built-in AMD loader
if (SitefinityDefine) {
    window.define = SitefinityDefine;
}

$(document).ready(function () {
    $('.slide').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        pauseOnHover: true,
        appendDots: '.slide-dots'
    });

    $('body').on('click', 'button.sf-SubmitButton', onSitefinityFormSubmit);

    $('.consumerSlide').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        pauseOnHover: true,
        appendDots: '.slide-dots',
    });

    $('.consumerSlide__mobile').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        pauseOnHover: true,
        appendDots: '.slide-dots',
    });

    $('.product__expandControl').on('click', function () {
        $(this).toggleClass('less-info').find('span').toggle();
    });

    window.appius.scroller.init();

});


function onHeroBannerScrolldownClick(e) {
    e.preventDefault();

    var $parentHero = $(this).parents('.hero-banner');
    appius.scroller.scrollToElem($('.main-content'), -$('header').innerHeight());
}

function onProductSearchLink(e) {
    e.preventDefault();

    if ($('.header__top .search__input').length > 0) {
        window.appius.scroller.scrollToElem($('.header__top .search__input'), -15);
        setTimeout(function () {
            $('.header__top .search__input').focus();
        }, 500);
    }
}


function onSitefinityFormSubmit() {
    $('button.sf-SubmitButton').addClass('btn--loading');
}


// on click eventListener for carousel full width click overlay
window.addEventListener('load', function () {
    var buttons = document.querySelectorAll('.js-link');
    buttons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            window.location = button.getAttribute('data-href')
        })
    })
});


// Sf Forms scrollTo validation message

var sfFormContainer = document.querySelector('[data-sf-role="form-container"]');
var sfErrorMessageContainer = document.querySelectorAll('[data-sf-role="error-message"]');

var observer = new MutationObserver(callback);

function callback(mutationList) {

    mutationList.forEach(function (mutation) {

        if (mutation.type === "attributes" && mutation.target.style.display == "block" ) {

            scrollToError(mutation);
        }
    });

};

var config = { attributes: true };
sfErrorMessageContainer.forEach(function (errorMessage) {
    observer.observe(errorMessage, config)
});

function scrollToError(mutation) {
    window.scrollTo({
        top: mutation.target.offsetTop,
        left: 0,
        behavior: "smooth",
    });
};